// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.logo {\n  margin-bottom: 2em;\n  max-width: 320px;\n}\n", ""]);
// Exports
module.exports = exports;
